<dp-header class="header">
    <dp-menu></dp-menu>
    <img [src]="'logo'" />
    <dp-profile></dp-profile>
</dp-header>
